export default __webpack_public_path__ + "static/img/1.36b4d9c.png";